import {
  Text,
} from '@chakra-ui/react';
import {
  useLengthVsVKT,
} from '@src/modules/performance/context/reports-api-hooks';
import TornadoBarChart from '@src/modules/performance/components/charts/TornadoBarChart';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Journey Distribution - ONRC',
  content: [
    {
      title: 'Length vs VKT (ONRC)',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The distribution of vehicle kilometres travelled and network length per ONRC category for the financial year.
    </Text>
    <Text fontSize="inherit" mb={2}>
      Road Efficiency Group Te Ringa Maimoa has calculated this result.
    </Text>
  </>,
      source:
  <Text fontSize="inherit" as="span">
    Transport Insights
  </Text>,
    },
  ],
};

function RoadNetworkUseJourneyDistributionOnrc() {
  const { data: lengthVsVktOnrc, isLoading: isLoadingLengthOnrc } = useLengthVsVKT('onrc');
  const isLoading = isLoadingLengthOnrc;

  // ONRC Chart
  const lengthVsVktOnrcData = [
    {
      name: 'Length %',
      type: 'bar',
      data: lengthVsVktOnrc?.map((item) => ({
        x: item.Category,
        y: item.PercTotalKm > 0.5 ? item.PercTotalKm * -1 : 0,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'Vehicle kilometres travelled %',
      type: 'bar',
      data: lengthVsVktOnrc?.map((item) => ({
        x: item.Category,
        y: item.PercTotalVKT > 0.5 ? item.PercTotalVKT : 0,
      })),
      color: CHART_COLOURS.red,
    },
  ];

  return (
    <ReportSection
      title="Journey Distribution - ONRC"
      isLoading={isLoading || !lengthVsVktOnrc}
      informationSource={informationSource}
      lockYear={lengthVsVktOnrc?.[0]?.LockYear}
    >
      <TornadoBarChart
        title="Length vs VKT (ONRC)"
        categories={[...new Set(lengthVsVktOnrc?.map((item) => item.Category))]}
        series={lengthVsVktOnrcData}
        dataLabelFormatter={(val) => {
          if (val === 0) {
            return '';
          }
          const labelFormatted = val > 0 ? `${val.toFixed(0)}%` : `${Math.abs(val).toFixed(0)}%`;
          return labelFormatted;
        }}
        suffix="%"
      />
    </ReportSection>
  );
}

export default RoadNetworkUseJourneyDistributionOnrc;
